import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, setInviteCode, setSessionToken, setStoredEmail } from "../lib/api";

export default function AuthVerify() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [status, setStatus] = useState<"verifying" | "success" | "error">("verifying");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setErrorMsg("Missing verification token");
      return;
    }

    api
      .verifyMagicLink(token)
      .then((res) => {
        if (res.valid) {
          setSessionToken(res.session_token);
          setInviteCode(res.invite_code);
          setStoredEmail(res.email);
          setStatus("success");
          // Redirect to dashboard after brief delay
          setTimeout(() => navigate("/dashboard", { replace: true }), 500);
        } else {
          setStatus("error");
          setErrorMsg("This link has expired or was already used. Please request a new one.");
        }
      })
      .catch(() => {
        setStatus("error");
        setErrorMsg("Verification failed. Please try again.");
      });
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <h1 className="text-3xl font-bold text-white mb-4">Architect</h1>

        {status === "verifying" && (
          <p className="text-slate-400">Verifying your login link...</p>
        )}

        {status === "success" && (
          <div>
            <p className="text-green-400 mb-2">Verified! Redirecting...</p>
          </div>
        )}

        {status === "error" && (
          <div>
            <p className="text-red-400 mb-4">{errorMsg}</p>
            <button
              onClick={() => navigate("/", { replace: true })}
              className="text-blue-400 hover:text-blue-300 underline text-sm"
            >
              Back to login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
